import React, { useEffect, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { Link } from "react-router-dom";
import { closeModal, SweetAlertShow } from "../master/Master";
import Swal from "sweetalert2";
import Master from "./Master";
import Pagination from "../components/Pagination";
import {
  busList,
  busStopAdd,
  busStopDelete,
  busStopsList,
  busStopUpdate,
} from "../../api/Transport";
import usePrivateLink from "../config/usePrivateLink";
import DownloadExcel from "../master/DownloadExcel";
import { PrintPage } from "../master/Print";

export default function BusRouteStopList() {
  const hasAccess = usePrivateLink();
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [buses, setBuses] = useState([]);
  const [data, setData] = useState([]);
  const [modalData, setModalData] = useState("");
  const [filters, setFilters] = useState({});

  useEffect(() => {
    const parseSessions = JSON.parse(localStorage.getItem("sessions") ?? "[]");
    setSessions(parseSessions);
  }, []);

  useEffect(() => {
    const activeSession = sessions?.find((s) => Number(s.status) === 1)?.id;
    setFilters((prev) => {
      if (prev.session_id || !activeSession) return prev;
      return { ...prev, session_id: activeSession };
    });
  }, [sessions]);

  const getBusList = async () => {
    try {
      const response = await busList();
      if (response.data.status) {
        setBuses(response.data.data || []);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    }
  };

  const busRoutesList = async () => {
    if (!filters?.session_id) return;
    setLoading(true);
    let url = "";
    Object.entries(filters).forEach(([key, value]) => {
      if (!value || !key) return;
      url += `${key}=${value}&`;
    });

    try {
      const response = await busStopsList(url);
      if (response.data.status) {
        setData(response.data?.data || []);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const newStop = async (e) => {
    e.preventDefault();
    setActionLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await busStopAdd(formData);
      if (response.data.status) {
        closeModal("AddStop");
        e.target.reset();
        busRoutesList();
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setActionLoading(false);
    }
  };

  const updateStop = async (e) => {
    e.preventDefault();
    setActionLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await busStopUpdate(formData);
      if (response.data.status) {
        closeModal("UpdateStop");
        busRoutesList();
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setActionLoading(false);
    }
  };

  const deleteBus = async (id) => {
    setActionLoading(true);
    try {
      const response = await busStopDelete({ id });
      if (response.data.status) {
        busRoutesList();
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setActionLoading(false);
    }
  };

  useEffect(() => {
    getBusList();
  }, []);

  useEffect(() => {
    busRoutesList();
  }, [filters]);

  const SkeletonRow = ({ i }) => (
    <tr key={i}>
      {Array.from({ length: 6 }).map((__, j) => (
        <td key={j}>
          <span className="placeholder-glow d-block">
            <span
              className="placeholder col-8"
              style={{ height: 14, borderRadius: 4 }}
            />
          </span>
        </td>
      ))}
    </tr>
  );

  const handleDownload = async (type = "excel") => {
    try {
      const downloadData = [];
      let firstUrl = "";
      Object.keys(filters).forEach((key) => {
        const value = filters[key];
        if (value !== undefined && value !== null && value !== "") {
          if (key !== "page") {
            firstUrl += `&${key}=${encodeURIComponent(value)}`;
          }
        }
      });

      const firstResponse = await busStopsList(`page=1${firstUrl}`);
      if (!firstResponse?.data?.status) {
        SweetAlertShow("info", "Warning", firstResponse?.data?.message);
        return;
      }

      const lastPage = firstResponse?.data?.data?.last_page || 1;

      const mapRows = (items) =>
        items.map((item) => ({
          "Bus Number": item?.bus?.bus_number ?? "",
          "Driver Name": item?.bus?.driver_name ?? "",
          "Driver Number": item?.bus?.driver_number ?? "",
          "Stop Name": item?.stop_name ?? "",
          "Stop Fee": item?.stop_fee ?? "",
        }));

      downloadData.push(...mapRows(firstResponse?.data?.data?.data || []));

      for (let page = 2; page <= lastPage; page++) {
        const response = await busStopsList(`page=${page}${firstUrl}`);

        if (response?.data?.status) {
          downloadData.push(...mapRows(response?.data?.data?.data || []));
        }
      }

      if (downloadData.length) {
        if (type === "excel") {
          const now = new Date();
          const fileName = `Report_${now.getFullYear()}_${now.getMonth() + 1
            }_${now.getDate()}_${now.getHours()}_${now.getMinutes()}`;

          DownloadExcel(downloadData, [], fileName, []);
        } else {
          PrintPage(downloadData);
        }
      } else {
        SweetAlertShow("info", "Info", "No records found");
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message || err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid mt-2">
                <div className="row py-5">
                  <Master />
                  <div className="col-md-12">
                    {/* Header card */}
                    <div className="card p-3 mb-3 shadow-sm border-0">
                      <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3">
                        <div className="d-flex align-items-center gap-3">
                          <div
                            style={{
                              width: 48,
                              height: 48,
                              borderRadius: "14px",
                              background:
                                "linear-gradient(135deg,#185fa5,#4f8cff)",
                              color: "#fff",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: 22,
                              boxShadow: "0 4px 12px rgba(24,95,165,0.25)",
                            }}
                          >
                            <i className="ri-map-pin-line" />
                          </div>
                          <div>
                            <h5 className="m-0 fw-bold">Route Stops</h5>
                            <small className="text-muted">
                              {loading
                                ? "Loading stops…"
                                : `${data?.total} stop${data?.total === 1 ? "" : "s"} on this session`}
                            </small>
                          </div>
                        </div>

                        <div className="d-flex align-items-center gap-2 flex-wrap">
                          <div
                            className="input-group"
                            style={{ maxWidth: 200 }}
                          >
                            <input
                              type="search"
                              className="form-control  input-uppercase"
                              placeholder="Search stop…"
                              value={filters?.search || ""}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  search: e.target.value.toUpperCase(),
                                })
                              }
                            />
                          </div>

                          <select
                            className="form-select"
                            style={{ maxWidth: 190 }}
                            value={filters?.session_id || ""}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                session_id: e.target.value,
                              })
                            }
                          >
                            <option value="all">All Sessions</option>
                            {sessions.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.session}:{" "}
                                {Number(item.status) === 1
                                  ? "Active"
                                  : "Inactive"}
                              </option>
                            ))}
                          </select>
                          {hasAccess("/bus/stop/import") && (
                            <Link
                              to={"/bus/stop/import"}
                              className={`btn btn-outline-primary btn-sm
                                                                  }`}
                            >
                              <i className="ri-upload-cloud-2-line me-2 ri-20px"></i>
                              Bus Stop Import
                            </Link>
                          )}
                          {hasAccess("/bus/export") && (
                            <button
                              type="button"
                              className="btn btn-outline-primary rounded-3 me-1"
                              onClick={() => handleDownload("excel")}
                            >
                              <i className="ri-file-excel-2-line me-2"></i>{" "}
                              Download
                            </button>
                          )}
                          {hasAccess("/bus/print") && (
                            <button
                              type="button"
                              className="btn btn-outline-info rounded-3"
                              onClick={() => handleDownload("print")}
                            >
                              <i className="ri-printer-line me-2"></i> Print
                            </button>
                          )}

                          {hasAccess("/bus/routes/add") && (
                            <Link
                              to=""
                              data-bs-toggle="modal"
                              data-bs-target="#AddStop"
                              title="Add New Stop"
                              className="btn btn-primary d-flex align-items-center gap-1 px-3"
                            >
                              <i className="ri-add-line" />
                              Add Stop
                            </Link>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Table card */}
                    <div className="card border-0 shadow-sm">
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-hover align-middle mb-0">
                            <thead>
                              <tr style={{ background: "#f8f9fb" }}>
                                <th className="ps-3">#</th>
                                <th>
                                  <i className="ri-map-pin-2-line me-1 text-muted" />
                                  Stop Name
                                </th>
                                <th>
                                  <i className="ri-bus-2-line me-1 text-muted" />
                                  Bus
                                </th>
                                <th>
                                  <i className="ri-user-3-line me-1 text-muted" />
                                  Driver
                                </th>
                                <th>
                                  <i className="ri-money-rupee-circle-line me-1 text-muted" />
                                  Stop Fee
                                </th>
                                <th>
                                  <i className="ri-group-line me-1 text-muted" />
                                  Students
                                </th>
                                <th className="text-end pe-3">
                                  <i className="ri-settings-3-line me-1 text-muted" />
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {loading ? (
                                Array.from({ length: 6 }).map((_, i) => (
                                  <SkeletonRow key={i} i={i} />
                                ))
                              ) : data?.data?.length === 0 ? (
                                <tr>
                                  <td colSpan={7} className="text-center py-5">
                                    <div className="d-flex flex-column align-items-center text-muted">
                                      <i
                                        className="ri-map-pin-line"
                                        style={{ fontSize: 48, opacity: 0.25 }}
                                      />
                                      <div className="mt-2 fw-semibold">
                                        No stops found
                                      </div>
                                      <small>
                                        Add a stop or adjust your filters
                                      </small>
                                    </div>
                                  </td>
                                </tr>
                              ) : (
                                data?.data?.map((bus, index) => (
                                  <tr key={bus.id}>
                                    <td className="ps-3 text-muted">
                                      {index + 1}
                                    </td>
                                    <td>
                                      <div className="d-flex align-items-center gap-2">
                                        <div
                                          className="rounded-3 d-flex align-items-center justify-content-center bg-label-primary"
                                          style={{
                                            width: 36,
                                            height: 36,
                                            flexShrink: 0,
                                          }}
                                        >
                                          <i className="ri-map-pin-2-fill" />
                                        </div>
                                        <span className="fw-medium text-capitalize">
                                          {bus.stop_name || "N/A"}
                                        </span>
                                      </div>
                                    </td>
                                    <td>
                                      {bus.bus?.bus_number ? (
                                        <span className="badge bg-label-info">
                                          <i className="ri-bus-2-line me-1" />
                                          {bus.bus.bus_number}
                                        </span>
                                      ) : (
                                        <span className="text-muted">N/A</span>
                                      )}
                                    </td>
                                    <td className="text-capitalize">
                                      {bus.bus?.driver_name ? (
                                        <div className="d-flex align-items-center gap-2">
                                          <i className="ri-account-circle-line text-muted" />
                                          {bus.bus.driver_name}
                                        </div>
                                      ) : (
                                        <span className="text-muted">N/A</span>
                                      )}
                                    </td>
                                    <td>
                                      <span className="fw-medium">
                                        <i className="ri-money-rupee-circle-line me-1 text-success" />
                                        {bus.stop_fee}
                                      </span>
                                    </td>
                                    <td>
                                      {(bus?.students_count ?? 0) > 0 ? (
                                        <span
                                          className="badge bg-label-secondary"
                                          title="Students assigned to this stop"
                                        >
                                          <i className="ri-group-line me-1" />
                                          {bus.students_count}
                                        </span>
                                      ) : (
                                        <span className="text-muted">—</span>
                                      )}
                                    </td>
                                    <td className="pe-3">
                                      <div className="d-flex justify-content-end gap-2">
                                        {hasAccess("/bus/routes/update") && (
                                          <button
                                            className="btn btn-sm btn-icon btn-outline-primary"
                                            title="Edit"
                                            onClick={() => setModalData(bus)}
                                            data-bs-toggle="modal"
                                            data-bs-target="#UpdateStop"
                                          >
                                            <i className="ri-pencil-line" />
                                          </button>
                                        )}

                                        {hasAccess("/bus/routes/delete") &&
                                          (bus?.students_count ?? 0) < 1 && (
                                            <button
                                              className="btn btn-sm btn-icon btn-outline-danger"
                                              title="Delete"
                                              onClick={() =>
                                                Swal.fire({
                                                  title: "Are you sure?",
                                                  text: "This action will permanently delete the stop!",
                                                  icon: "warning",
                                                  showCancelButton: true,
                                                  confirmButtonColor: "#d33",
                                                  cancelButtonColor: "#6c757d",
                                                  confirmButtonText:
                                                    "Yes, delete it!",
                                                  cancelButtonText: "Cancel",
                                                }).then((result) => {
                                                  if (result.isConfirmed)
                                                    deleteBus(bus.id);
                                                })
                                              }
                                            >
                                              <i className="ri-delete-bin-line" />
                                            </button>
                                          )}

                                        {(bus?.students_count ?? 0) > 0 &&
                                          !hasAccess("/bus/routes/delete") && (
                                            <span
                                              className="btn btn-sm btn-icon btn-outline-secondary disabled"
                                              title="Cannot delete — students assigned"
                                            >
                                              <i className="ri-lock-line" />
                                            </span>
                                          )}
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                          {!loading && data?.total > 0 && (
                            <>
                              <Pagination
                                data={data}
                                setFilters={setFilters}
                                filters={filters}
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add Stop Modal */}
      <div className="modal fade" id="AddStop" tabIndex={-1} aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <form onSubmit={newStop}>
              <div className="modal-header bg-label-primary p-4">
                <h1 className="modal-title fs-5 d-flex align-items-center gap-2">
                  <i className="ri-map-pin-add-line" /> Add Route Stop
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className="mb-3 form-floating form-floating-outline">
                  <select className="form-select" name="session_id" required>
                    <option value="" disabled>
                      Select Session
                    </option>
                    {sessions.map((item) => (
                      <option
                        key={item.id}
                        value={item.id}
                        selected={Number(item.status) === 1}
                      >
                        {item.session}:{" "}
                        {Number(item.status) === 1 ? "Active" : "Inactive"}
                      </option>
                    ))}
                  </select>
                  <label>Select Session</label>
                </div>

                <div className="mb-3 form-floating form-floating-outline">
                  <select className="form-select" name="bus_id" required>
                    <option value="" disabled>
                      Select Bus
                    </option>
                    {buses.map((bus) => (
                      <option key={bus.id} value={bus.id}>
                        {bus.bus_number}
                      </option>
                    ))}
                  </select>
                  <label>-- Select Bus --</label>
                </div>
                <div className="mb-3 form-floating form-floating-outline">
                  <input
                    type="text"
                    className="form-control input-uppercase"
                    name="stop_name"
                    required
                    placeholder="Route Stop Name"
                  />
                  <label>Route Stop Name</label>
                </div>
                <div className="mb-3 form-floating form-floating-outline">
                  <input
                    type="number"
                    className="form-control"
                    name="stop_fee"
                    required
                    min="0"
                    placeholder="Route Stop Fee"
                  />
                  <label>Route Stop Fee</label>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={actionLoading}
                >
                  {actionLoading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    <>
                      <i className="ri-save-line me-1" />
                      Submit
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="UpdateStop"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <form onSubmit={updateStop}>
              <div className="modal-header bg-label-primary p-4">
                <h1 className="modal-title fs-5 d-flex align-items-center gap-2">
                  <i className="ri-pencil-line" /> Update Route Stop
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <input type="hidden" name="id" value={modalData?.id || ""} />

                <div className="mb-3 form-floating form-floating-outline">
                  <select
                    className="form-select"
                    name="session_id"
                    required
                    onChange={(e) => {
                      setModalData({
                        ...modalData,
                        session_id: e.target.value,
                      });
                    }}
                    value={modalData?.session_id}
                  >
                    <option value="" disabled>
                      Select Session
                    </option>
                    {sessions.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.session}:{" "}
                        {Number(item.status) === 1 ? "Active" : "Inactive"}
                      </option>
                    ))}
                  </select>
                  <label>Select Session</label>
                </div>

                <div className="mb-3 form-floating form-floating-outline">
                  <select
                    className="form-select"
                    name="bus_id"
                    required
                    onChange={(e) => {
                      setModalData({
                        ...modalData,
                        bus_id: e.target.value,
                      });
                    }}
                    value={modalData?.bus_id}
                  >
                    <option value="" disabled>
                      Select Bus
                    </option>
                    {buses.map((bus) => (
                      <option key={bus.id} value={bus.id}>
                        {bus.bus_number}
                      </option>
                    ))}
                  </select>
                  <label>-- Select Bus --</label>
                </div>
                <div className="mb-3 form-floating form-floating-outline">
                  <input
                    type="text"
                    className="form-control input-uppercase"
                    name="stop_name"
                    required
                    placeholder="Stop Name"
                    onChange={(e) => {
                      setModalData({
                        ...modalData,
                        stop_name: e.target.value,
                      });
                    }}
                    value={modalData?.stop_name}
                  />
                  <label>Stop Name</label>
                </div>
                <div className="mb-3 form-floating form-floating-outline">
                  <input
                    type="number"
                    className="form-control"
                    name="stop_fee"
                    required
                    min="0"
                    placeholder="Stop Fee"
                    onChange={(e) => {
                      setModalData({
                        ...modalData,
                        stop_fee: e.target.value,
                      });
                    }}
                    value={modalData?.stop_fee}
                  />
                  <label>Stop Fee</label>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={actionLoading}
                >
                  {actionLoading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    <>
                      <i className="ri-save-line me-1" />
                      Submit
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
